<template>
	<div class="d-flex align-items-center">
		<div v-for="(label, i) in steps" :key="i" class="d-flex align-items-center">
			<div class="step-indicator"
				:class="{
					'step-active':  currentStep === i + 1,
					'step-done':    currentStep >  i + 1,
					'step-pending': currentStep <  i + 1,
				}"
			>
				<span v-if="currentStep > i + 1">✓</span>
				<span v-else>{{ i + 1 }}</span>
			</div>
			<span class="ml-2 small" :class="{ 'font-weight-bold': currentStep === i + 1 }">{{ label }}</span>
			<span v-if="i < steps.length - 1" class="mx-3 text-muted">›</span>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		steps:       { type: Array,  required: true },
		currentStep: { type: Number, required: true },
	},
};
</script>

<style scoped>
.step-indicator {
	width: 28px;
	height: 28px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 13px;
	font-weight: bold;
	flex-shrink: 0;
}
.step-active  { background: #007bff; color: #fff; }
.step-done    { background: #28a745; color: #fff; }
.step-pending { background: #e9ecef; color: #6c757d; }
</style>
